module.exports = __webpack_public_path__ + "img/sea of tranquility near side.d9206985.png";